import React,{Component} from "react";
// import $ from 'jquery';
import { withRouter } from 'react-router';
import Wrp from '../../../hoc/Wrp/Wrp';
// import Pagination from '../../../Components/UI/TableModal/Pagination';
// import {fileNameShortenForDisplay,parameterizedURLAccessToken} from '../../../Utils/CommonFunctions';
import moment from 'moment';
import Icons from "../../../Components/Icons/Icons";
import DetailMessage from './UI/DetailMessage';
import ComposeMail from '../ComposeMail';
import ReactToPrint from "react-to-print";
import Skeleton from '../../../Components/Skeleton';
import {getUserTimeZone} from '../../../Utils/UserFunctions'


class MailContent extends Component {

    
	
    constructor(props) {
        super(props);
        this.listInnerRef = React.createRef();
        this.state = {
        }
    }

    onScroll = () => {        
        if (this.listInnerRef.current) {            
          const { scrollTop, scrollHeight, clientHeight } = this.listInnerRef.current;
          //console.log('sssssss scroll listInnerRef',scrollTop + clientHeight, scrollHeight-1)
          let roundOffNumber = Math.floor(scrollTop + clientHeight);
          if ((roundOffNumber === scrollHeight) || (roundOffNumber === scrollHeight - 1) || ((roundOffNumber) - 1 === scrollHeight)) {            // TO SOMETHING HERE
            //console.log(scrollTop, clientHeight, 'Reached bottom',scrollHeight)
            this.props.callEmailPage(this.props.match.params.emailName, 'yes');
          }
        }
      };

    componentWillMount = () => {
        // console.log(this.props.tableRecords, 'this.props.tableRecords MailContent')
    }

    componentWillUpdate = (nextProps, prevProps) =>{
        // console.log(nextProps.location.pathname+'---'+this.props.location.pathname)
        //console.log(nextProps.pageType, 'nextProps.pageType', this.props.pageType, 'this.props.pageType')
        if(nextProps.location.pathname!==this.props.location.pathname){
          setTimeout(() => {
            //this.layoutsFormsList(this.state.tableRecords.pagination,true);
            //console.log(this.props.emailName, 'this.props.maincontent')
            //console.log(this.props.match.params.emailName, 'this.props.match.url.maincontent')
            if(this.props.match.params.windowId!=='view'){
                this.props.callEmailPage(this.props.match.params.emailName);
            }

          }, 100);
        }
        // else if((nextProps.location.pathname===this.props.location.pathname && this.props.pageType === 'View')){
        //     setTimeout(() => {
        //     //this.layoutsFormsList(this.state.tableRecords.pagination,true);
        //     //console.log(this.props.emailName, 'this.props.maincontent')
        //     //console.log(this.props.match.params.emailName, 'this.props.match.url.maincontent')
        //     this.props.callEmailPage(this.props.match.params.emailName);

        //   }, 100);    
        // }
    }

    componentDidUpdate = () => {
        //console.log('componentDidUpdate MailContent')
        //console.log(this.props.match.params.emailName, 'this.props.match.url.maincontent')
        //console.log(this.props.tableRecords, 'this.props.tableRecords MailContent')
        
    }    

    capitalize = (s) => {
      if (typeof s !== 'string') return ''
      return s.charAt(0).toUpperCase() + s.slice(1)
    }

    backAction = () => {
        let emailPage = this.props.match.params.emailName;
        this.props.history.push("/email-settings/email/"+emailPage);
    }    


    render(){
        const tableData = this.props.tableRecords.tableData;
        const {emailConfigList} =  this.props;
        let selectedRows = this.props.tableRecords.selectedRows;
        let isSelectAll = (this.props.tableRecords.isSelectAll === true )?true:false;
        let emailPage = this.props.match.params.emailName;
        let importantArr = this.props.importantHandleArr;

        let indexIm = importantArr.indexOf(1);
        let indexUnIm = importantArr.indexOf(0);
        let isShowImportantIcon = false;
        let isShowUnImportantIcon = false;
        if (indexIm !== -1) {
            isShowUnImportantIcon = true;
        }
        if (indexUnIm !== -1) {
            isShowImportantIcon = true;
        }
        let  lastSync ='';
        let  emailConfigStatus ='';
        let emailSyncMessage = "";
        let userDateCurrentDate = moment().tz(getUserTimeZone()).format('YYYY-MM-DDTHH:mm:ss');
        let currentTime = moment(userDateCurrentDate,'YYYY-MM-DDTHH:mm:ss')
        if(emailConfigList!==null){
            emailConfigList.map((item)=>{
                if( item.id===this.props.emailConfigId){
                    lastSync = moment(item.synced_at,"YYYY-MM-DDTHH:mm:ss");
                    emailConfigStatus =item.sync_status;
                    emailSyncMessage = item.sync_message;
                }
            })
        }
        let ConvertedLastSync ='';
        if(currentTime!==null && lastSync!==''){
            var duration = moment.duration(currentTime.diff(lastSync));
            var days = duration.days();
            var hours = duration.hours();
            var minutes = duration.minutes();
            if(days>0){
                ConvertedLastSync = days +' days ago';
            }else if (hours>0){
                ConvertedLastSync = hours +' hours ago';
            }else if(minutes>0){
                ConvertedLastSync = minutes + ' minutes ago'
            }
        }

        // Data for View Page
        let emailData = this.props.mailData;
        // Endss
        //console.log("tableData------------->",tableData, isSelectAll);

        let headerActionClass = 'none';
        if(selectedRows.length > 0){
            headerActionClass = 'flex';
        }
        let isDataLoading = this.props.isDataLoading;

        //console.log(this.props.isMobileWebView, 'this.props.isMobileWebView')
        let wClass = "280px";
        let gClassMessView = "";
        let mClassMessView = "";
        if(this.props.isMobileWebView === true){
            wClass = "100%";            
        }

        if(this.props.isMobileWebView === true && this.props.isMobileWebMessageView === false){            
            //gClassMessView = "d-none d-sm-none d-md-block";
            gClassMessView = "d-sm-none";
        }

        if(this.props.isMobileWebView === true && this.props.isMobileWebMessageView === true){
            mClassMessView = "emailContent_Mview";   
        }else if(this.props.isMobileWebView === false && this.props.isMobileWebMessageView === false){
            mClassMessView = "w-100" 
        }

        let pageTypeClass = 'fas fa-inbox';
        if(this.props.emailName === 'inbox'){
            pageTypeClass = 'fas fa-inbox';
        }else if(this.props.emailName === 'outbox'){
            pageTypeClass = 'fas fa-envelope';
        }else if(this.props.emailName === 'important'){
            pageTypeClass = 'fas fa-exclamation-circle'
        }else if(this.props.emailName === 'drafts'){
            pageTypeClass = 'fas fa-envelope-open';
        }else if(this.props.emailName === 'trash'){
            pageTypeClass = 'fas fa-trash-alt';
        }else if(this.props.emailName === 'archive'){
            pageTypeClass = 'fas fa-archive';
        }

        //console.log(selectedRows,'selectedRows===')

        return(
            <Wrp>

                <div className="maillistOuter" style={{}}>

                    <div className="filter_Box no-bd crmEmail" style={{"width":`${wClass}`}}>
                        <div className="filter_Header p-0 position-relative" style={{"padding-left": "10px"}}>
                            <div className="d-flex align-items-center justify-content-between border-bottom px-2 py-1 text-bold">
                                <div>
                                    { emailPage.toLowerCase() === 'inbox' ?
                                    
                                    <button title="Refresh" type="button" className="btn btn-round btn-border border-default">
                                        <span className="cursor-pointer" onClick={this.props.refreshHandler}>
                                            <i className="fa fa-sync-alt "></i>
                                        </span>
                                    </button>
                                    : null }
                                </div>
                                <div>

                                    <i className={pageTypeClass}></i> 
                                    <span className="pr-1" style={{marginLeft:5}}> {this.capitalize(this.props.emailName)} </span> 
                                    
                                    {/*| <span className="pl-1 text-small"> System@gmail.com </span> */}
                                </div>

                                <button type="button" className="btn btn-icon btn-sm btn-round btn-info custom-toggle3"   title="Compose Email"  onClick={this.props.toggleModelHandler}><i className="fas fa-pen"></i></button>
                            </div>
                            <div className="input-group px-2 py-1">

                                {
                                    (this.props.isMobileWebView)?
                                    <div className="input-group-prepend cursor-pointer" onClick={this.props.toggleMobileWebMenu}>
                                        <span className="input-group-text">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="#708090">
                                                <path opacity="0.5" d="M14.2657 11.4343L18.45 7.25C18.8642 6.83579 18.8642 6.16421 18.45 5.75C18.0358 5.33579 17.3642 5.33579 16.95 5.75L11.4071 11.2929C11.0166 11.6834 11.0166 12.3166 11.4071 12.7071L16.95 18.25C17.3642 18.6642 18.0358 18.6642 18.45 18.25C18.8642 17.8358 18.8642 17.1642 18.45 16.75L14.2657 12.5657C13.9533 12.2533 13.9533 11.7467 14.2657 11.4343Z" fill="#708090"></path>
                                                <path d="M8.2657 11.4343L12.45 7.25C12.8642 6.83579 12.8642 6.16421 12.45 5.75C12.0358 5.33579 11.3642 5.33579 10.95 5.75L5.40712 11.2929C5.01659 11.6834 5.01659 12.3166 5.40712 12.7071L10.95 18.25C11.3642 18.6642 12.0358 18.6642 12.45 18.25C12.8642 17.8358 12.8642 17.1642 12.45 16.75L8.2657 12.5657C7.95328 12.2533 7.95328 11.7467 8.2657 11.4343Z" fill="#708090"></path>
                                            </svg>
                                        </span>
                                    </div>
                                    :
                                    null
                                }
                                
                                <input type="text" className="form-control" placeholder="Search here...." onChange={e => this.props.searchFilterHandler(e)} />
                                <div className="input-group-append cursor-pointer" onClick={this.props.toggleFilter}>
                                    <span className="input-group-text">
                                        <Icons iconType="Filter" />
                                    </span>
                                </div>
                            </div>

                            {
                                this.props.emailConfigName!=='' ?
                                <div>
                                                                <div className="px-2 d-flex align-items-center justify-space-between">  
                                    <span  className=" text-small third_dark_color"> Filtered by : </span>
                                    <span className="w-50 text-truncate text-small text-info text-bold pr-2 m-0 badge p-1"> {this.props.emailConfigName}   </span>{ 
                                    (emailConfigStatus!=='')?
                                    (emailConfigStatus==='COMPLETED')?
                                    <span className='px-1'>
                                         <i className="fas fa-check-circle fa-1x"  data-fa-transform="shrink-8" style={{color:'green'}} ></i>
                                     </span>:
                                    (emailConfigStatus==="INPROGRESS")?<span className="text-info"> <i className="fa fa-circle-notch fa-rotate fa-spin ml-2"></i></span>:
                                    <span className='px-1'> <i className="fas fa-exclamation-triangle fa-1x text-danger"  data-fa-transform="shrink-8"  ></i> </span>:""
                                    }
                                        
                                </div>
                                <div className="pb-1 px-2 text-left" >
                                    <span className="text-small black">
                                        {(emailConfigStatus==="INPROGRESS")? <marquee width="100%" direction="left" height="auto" className=" text-small text-info ">{emailSyncMessage}</marquee>:
                                            (emailConfigStatus==="FAILED")? <marquee width="100%" direction="left" height="auto" className=" text-small text-danger">{emailSyncMessage}</marquee>: "" }
                                        {(ConvertedLastSync!=='')? <span className="text-small black"> {'last sync '+ConvertedLastSync} </span> :''}
                                    </span>
                                 </div>

                                </div>
                                :
                                <></>
                            }
                            
                            <div className="d-flex1 align-items-center bg-white w-100 p-2 border-bottom justify-content-between" style={{"position":"absolute","left":"0","top":"40px","display":`${headerActionClass}`}}> 
                                
                                <div className=""> 
                                    <label className="form-check-label"> 
                                        <input type="checkbox" className="form-check-input" checked={isSelectAll} onChange={this.props.clearOrSelectAllRows.bind(this,selectedRows,isSelectAll)} /> 
                                    </label>
                               
                                    {
                                        (isShowImportantIcon === true) ?
                                        <span className="pl-1" onClick={e=>this.props.withSelectedHandler(true, 'important')}> 
                                            <a className="important cursor-pointer" title="Mark as important">
                                                <Icons iconType="Important" />
                                            </a>
                                        </span>
                                        :
                                        <></>
                                    }

                                    {
                                        (isShowUnImportantIcon === true) ?
                                        <span className="pl-1" onClick={e=>this.props.withSelectedHandler(false, 'important')}> 
                                            <a className="important cursor-pointer" title="Mark as un important">
                                                <Icons iconType="UnImportant" />
                                            </a>
                                        </span>
                                        :
                                        <></>
                                    }
                                                                         
                                    
                                    <span className="pl-1" onClick={e=>this.props.withSelectedHandler(true, 'read')}> 
                                        <a className="important cursor-pointer" title="Mark as Read">
                                            <Icons iconType="EmailMarkAsRead" />
                                        </a>
                                    </span>

                                    <span className="pl-1" onClick={e=>this.props.withSelectedHandler(false, 'read')}> 
                                        <a className="important cursor-pointer" title="Mark as Un Read">
                                            <Icons iconType="EmailMarkAsUnRead" />
                                        </a>
                                    </span>

                                    {
                                        (this.props.emailName !== 'archive' && this.props.emailName !== 'trash')?
                                        <span className="pl-1"> 
                                            <a className="important cursor-pointer" title="Archive" onClick={e=>this.props.withSelectedHandler(true, 'archive')}> 
                                                <Icons iconType="EmailArchive" />
                                            </a>
                                        </span>
                                        :
                                        <></>
                                    }
                                    

                                    <span className="pl-1" onClick={this.props.deleteMessageHandler}> 
                                        <a className="important cursor-pointer" title={(this.props.emailName === 'trash')? "Delete permanently" :"Moved to trash"}> 
                                            <Icons iconType="EmailTrash" />
                                        </a>
                                    </span>  
                                    <span className="badge badge-warning p-1">{selectedRows.length} selected</span>

                                </div>

                                {/*<div className="cursor-pointer">
                                    <i className="fas fa-times fa-lg third_dark_color"></i>
                                </div>*/}
                            </div>
                        </div>
                        <div className="filter_Body bg-white p-0 mt-1" id="notificationMainDiv" onScroll={() => this.onScroll()} ref={this.listInnerRef}>
                            <Wrp>
                                {
                                    (isDataLoading===true) ?
                                        (tableData.status===200 && tableData.data.length>0) ? 
                                            tableData.data.map((rows,rowIndex)=>{
                                                let colInc = 0;
                                                let colIndex = 0;
                                                let msgDate = moment(rows.message_date).format('DD MMM');
                                                let rowsData = (rows.data)?rows.data:rows;
                                                let stripedBody = '';
                                                if(rows.body !== undefined){
                                                  let stripedBody =   rows.body.replace(/<(.|\n)*?>/g, '');
                                                  //stripedBody = stripedBody.replace('&nbsp;', ' ');
                                                  stripedBody = stripedBody.replace(/&nbsp;/g, ' ');
                                                  stripedBody = stripedBody.substring(0,150);
                                                }
                                                let stripedSubject = rows.subject.replace(/<(.|\n)*?>/g, '');
                                                //stripedBody = stripedBody.replace('&nbsp;', ' ');
                                                stripedSubject = stripedSubject.replace(/&nbsp;/g, ' ');
                                                stripedSubject = stripedSubject.substring(0,150);

                                                //console.log(this.props.tableRecords.selectedRows, 'this.props.tableRecords.selectedRows')
                                                let message_group_id = rows.itemData.message_group_id;
                                                //let isChecked = (this.props.tableRecords.selectedRows.indexOf(message_group_id)!== -1)?true:false;
                                                let isChecked = (this.props.tableRecords.selectedRows.indexOf(message_group_id)!== -1)?true:false;
                                                let isRead = 'new_mail';
                                                if(emailPage.toLowerCase() === 'inbox') {
                                                    //isRead = (rows.itemData.read === true)? 'read':'';
                                                }
                                                isRead = (rows.itemData.read === true)? '':'new_mail';
                                                let isImpotant = rows.itemData.important;                                            
                                                let isDelievered = rows.itemData.status.toLowerCase() === 'queue' ? true : false;
                                                let status = rows.itemData.status.toLowerCase();
                                                const checkIsRead = rows.itemData.read;                                            
                                                let isAttachment = rows.itemData.attachments;
                                                let isImpotantClass = "";
                                                let isImpotantText = "un important";
                                                if(isImpotant){
                                                    isImpotantClass = "marked";
                                                    isImpotantText = "important";
                                                }

                                                let isCurrentRowActiveClass='';
                                                if(this.props.currentMailRowId === message_group_id){
                                                    isCurrentRowActiveClass = 'active';    
                                                }

                                                if(this.props.emailName === 'outbox'){
                                                    isRead = '';    
                                                }                                                
                                                                                                
                                                return (
                                                    <Wrp>
                                                        <div className={`mail-list ${isRead} ${isCurrentRowActiveClass}`}>

                                                            <div className="d-flex align-items-center">
                                                                <div className=""> 
                                                                    <label className="form-check-label"> 
                                                                        <input type="checkbox" checked={isChecked}  onChange={this.props.checkBoxOnChangeHandler.bind(this,rows.rowId,isChecked,message_group_id,isImpotant)} className="form-check-input" /> 
                                                                    </label>
                                                                </div>
                                                                <div className="content" onClick={e => this.props.messageClickHandler(emailPage, rows.itemData,'',1)}>
                                                                    <p className="sender-name">{rows.itemData.from}</p>
                                                                    <p className="message_text">{stripedSubject}</p>
                                                                </div>
                                                            </div>
                                                            <div className="email-footer" onClick={e => this.props.messageClickHandler(emailPage, rows.itemData,'',1)}>
                                                                <div className="email-action pl-4">
                                                                    <a className={`important ${isImpotantClass}`} title={`Marked as ${isImpotantText}`}> 
                                                                        <Icons iconType="EmailMarkAsImportant" /> 
                                                                    </a> 
                                                                    {
                                                                        (isAttachment === true)?
                                                                            <a className="attachment"> 
                                                                                <Icons iconType="EmailAttachment" /> 
                                                                            </a>
                                                                        :
                                                                        <></>
                                                                    }                                  
                                                                </div>
                                                                <span className="email-time"> 
                                                                {msgDate} 
                                                                {
                                                                    emailPage === 'outbox' ?
                                                                        <span>&nbsp; 
                                                                        {
                                                                            status === 'send' ?
                                                                                checkIsRead ?
                                                                                    <Icons iconType={'EmailRead'}/>
                                                                                :
                                                                                    <Icons iconType={'EmailDelivered'}/>
                                                                            : status === 'queued' ?
                                                                                <Icons iconType={'EmailQueued'}/>
                                                                            :
                                                                                <Icons iconType={'EmailFailed'}/>
                                                                        }
                                                                        </span>
                                                                    : 
                                                                        null
                                                                }
                                                                </span>
                                                            </div>

                                                            
                                                        </div> 
                                                    </Wrp>  
                                                )
                                            })
                                        :
                                        <Wrp>                                        
                                            <div className="mail-list">                                                 
                                                <div className="email-list-actions">
                                                    <div className="d-flex"></div>
                                                </div>
                                                <div className="email-list-detail">                                                                                     
                                                    <p className="msg">No Messages</p>
                                                </div>
                                            </div>    
                                        </Wrp>
                                    :

                                    <Wrp>                                        
                                        <div className="mail-list">
                                            <Skeleton type="EmailListing" />                                              
                                        </div>    
                                    </Wrp>
                                       
                                }
                            </Wrp>
                        </div>
                    </div>
                    <div className={this.props.isFilterOpen === true ? '' : "hide"}>
                        <span className="mt-0 p-0 dropdown-menu show dropdown-menu-left dropdownmenu-content" style={{"top": '0', 'width': '230px', 'height': '100%'}}>
                              
                            <div className="clearfix"> 
                                <div className="card-header p-1">

                                    <div className="d-flex">
                                             
                                    <h6 className="p-2"> Filter by  Email </h6> 
                                             
                                        <a onClick={this.props.toggleFilter} className="icon-right cursor-pointer"><i className="fas fa-times-circle secondary_color"></i></a>
                                    </div>

                                    <input type="text" className="form-control form-control-sm" placeholder="Search here...." onChange={e => this.props.searchConfigFilterHandler(e)} /> 
                                        
                                     
                                </div>
                                <div className="card-body pt-0 pb-0 fixedHeight">
                                    <div className="card-list">
                                    {
                                        (emailConfigList.length>0 ) ?
                                        emailConfigList.map((item, index) => {
                                                return (
                                                    <div className="w-100 d-flex align-items-center justify-content-center mb-1">
                                                        <div className="w-100 ">
                                                            <label className="w-100 d-flex align-items-center mb-0 cursor-pointer">
                                                            <input type="radio" onChange={e=>this.props.changeHandler(e, item.user_name,item.id)} name="emailConfigId" value={item.id} checked={item.id === this.props.emailConfigId ? true : false} />
                                                            <span className="pl-2 w-100 text-truncate">  {item.user_name} </span>                                                            </label>
                                                        </div>                   
                                                    </div> 
                                                    );

                                            })
                                        :
                                        <div className="w-100 d-flex align-items-center justify-content-center mb-1">
                                            <div className="w-100 ">
                                                <label className="w-100 d-flex align-items-center mb-0 cursor-pointer">
                                                    <span className="pl-2">No Records</span>
                                                </label>
                                            </div>                   
                                        </div>
                                        
                                    }   
                                        
                                    </div>
                                </div>
                            </div>
                           
                        </span>
                    </div>

                </div>

                {
                    emailData &&  emailData.length > 0 ?
                    <Wrp>                        
                        <div className={mClassMessView}>
                            <div className={`view w-100 border-left mail-wrapper break-content ${gClassMessView}`}>
                                <div className="filter_Box no-bd crmEmail">
                                    <div className="filter_Header align-items-center d-flex justify-content-between" style={{"height": "50px"}}>
                                        <h5 className="mb-0 text-truncate w-75 text-bold"> 
                                            {
                                                this.props.isMobileWebView === true ? 
                                                <i onClick={this.props.toggleMobileWebMessageView} className="fas fa-arrow-left secondary_color mr-2 cursor-pointer"></i>
                                                :
                                                null
                                            }                                        
                                            {emailData[0].subject} 
                                        </h5>
                                        <div className="controls mt-3 mt-lg-0">
                                            <div className="icons">
                                                {
                                                emailPage.toLowerCase() === 'drafts' ?
                                                    <a className="pr-2 custom-toggle3" title="Resend" onClick={e => this.props.messageClickHandler(emailPage, emailData[0], true)}>
                                                        <i className="fas fa-redo text-muted"></i>
                                                    </a>
                                                : null
                                                }
                                                <a className="pr-2 custom-toggle3" title="Forward">
                                                    <Icons iconType="ForwardIcon" />
                                                </a>

                                                <a className="pr-2" title="Print">
                                                <ReactToPrint
                                                      trigger={() => <a href="#"><Icons iconType="PrintIcon" /></a>}
                                                      content={() => this.componentRef}
                                                    />
                                                    {/*<Icons iconType="PrintIcon" />*/}
                                                </a>
                                                <a onClick={e => this.props.deleteMessageHandlerAlone(emailData[0])} className="pr-2 cursor-pointer" title="Delete">
                                                    <Icons iconType="MailDeleteIcon" />
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="filter_Body  bg-white mail-content p-0" ref={el => (this.componentRef = el)}  >
                                        <Wrp>
                                            {
                                                emailData ?
                                                    emailData.map((item,ind) => {
                                                        let hideShow = 'hide';
                                                        if(this.props.showDetailedMessage.indexOf(ind) > -1){
                                                            hideShow = 'show';    
                                                        }else{
                                                            hideShow = 'hide';
                                                        }
                                                        return (
                                                            <DetailMessage 
                                                                {...this.props}
                                                                emailData={item}
                                                                indexLoop={ind}
                                                                hideShow={hideShow}
                                                            />
                                                        )
                                                    })
                                                : null
                                            }
                                            {this.props.isComposeMail === true ?
                                            <ComposeMail
                                              composePage="main"
                                              isComposeMail={this.props.isComposeMail}
                                              isDraft={this.props.isDraft}
                                              composeMailHandler={this.props.replyToMailHandlerCallback}
                                              emailMessageList={this.props.emailMessageList}
                                              mailData={this.props.mailData[0]} 
                                              isReplyTo={this.props.isReplyTo}
                                              replyToData={this.props.replyToData}
                                              replyMessageClose={this.props.replyMessageClose}
                                              />
                                              :
                                            ''}

                                            

                                        </Wrp> 
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Wrp>
                    :
                    <div className="view w-100 border-left mail-wrapper d-none d-sm-none d-md-block">
                        <div className="filter_Box no-bd crmEmail">
                            <div className="filter_Header align-items-center d-flex justify-content-between" style={{"height": "50px"}}>
                                <h5 className="mb-0 text-truncate w-75 text-bold"> No Message</h5>
                            </div>
                        </div>
                    </div>
                }

                

                
            </Wrp>
        )    
    }
	
} 

export default (withRouter(MailContent));